var i = Object.defineProperty;
var s = (o, e, t) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var n = (o, e, t) => (s(o, typeof e != "symbol" ? e + "" : e, t), t);
class E {
  /**
   * constructor
   * @param vendor abstraction for tracking vendor implementation
   * @param getSuperEventProps function that returns the super properties of the app
   * @param getEngagementEventProps funtion that returns the engagement properties
   * @param onError function for catching errors from the outsite
   */
  constructor(e) {
    /**
     * logEvent will be called in each log method.
     * This method will be defined on each application and passed thought the constructor of this class
     */
    n(this, "_vendor");
    /**
     * Function that handle the error
     * In case that we want to control errors for logging them or catch them
     */
    n(this, "onError");
    this._vendor = e.vendor, this.onError = e.onError;
  }
  /**
   * Sets vendor's user properties
   * @param properties user properties
   */
  setUserProperties(e) {
    this._vendor.setUserProperties(e);
  }
  /**
   * Calls vendor's tracking event with error handling
   * @param event event name
   * @param props properties
   */
  logEvent(e, t) {
    var r;
    try {
      this._vendor.logEvent(e, t);
    } catch (v) {
      (r = this.onError) == null || r.call(this, v);
    }
  }
  /**
   * logPageViewedEvent for all the page viewed events - mostly called on page load
   * @param props properties of the event
   */
  logPageViewedEvent(e) {
    this.logEvent("page viewed", e);
  }
  /**
   * logSystemEvent to log any system event
   * @param eventName name of the event: log or error
   * @param props object with properties
   */
  logSystemEvent(e, t) {
    this._vendor.logEvent(e, t);
  }
  /**
   * logProcessEvent: open for any process evemt
   * @param eventName as string with the name of the process
   * @param props object with properties
   */
  logProcessEvent(e, t) {
    this._vendor.logEvent(e, t);
  }
  /**
   * logContentViewedEvent for all the content viewed events - mostly called to track the Errors
   * @param {ContentViewedEventProps} props properties of the event
   * @throws InvalidPropertiesError
   */
  logContentViewedEvent(e) {
    this.logEvent("content viewed", e);
  }
  /**
   * logClickEvent for all the click type events
   * @param {ClickEventProps} props properties of the event
   * @throws InvalidPropertiesError
   */
  logClickEvent(e) {
    this.logEvent("click", e);
  }
  /**
   * logSlideEvent for all the slide events - Mostly called on the Slider components
   * @param props properties of the event
   * @throws InvalidPropertiesError
   */
  logSlideEvent(e) {
    this.logEvent("slide", e);
  }
  /**
   * logInputEvent for the input events - Mostly called from different text-field components
   * @param props properties of the event
   * @throws InvalidPropertiesError
   */
  logInputEvent(e) {
    this.logEvent("input", e);
  }
}
export {
  E as OneSnapTracking
};
